import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AuditConstants } from '../../shared/constants/audit-constants';
import { DocumentLifeCycle } from '../models/document-life-cycle';

@Component({
  selector: 'app-document-audit-life-cycle',
  templateUrl: './document-audit-life-cycle.component.html',
  styleUrls: ['./document-audit-life-cycle.component.scss'],
})
export class DocumentAuditLifeCycleComponent implements OnInit {
  @Input() auditLifecycleInput: DocumentLifeCycle[] = [];
  constructor() { }
  private phaseOrder = AuditConstants.phaseOrder;
  ngOnInit(): void {
    const datePipe = new DatePipe('en-US');
    this.auditLifecycleInput.forEach((entity, i) => {
      const currentPhaseIndex = this.phaseOrder.indexOf(entity.phaseName);
      const prevEntity = this.auditLifecycleInput[i - 1];
      const prevPhaseIndex = prevEntity ? this.phaseOrder.indexOf(prevEntity.phaseName) : -1;
      entity.arrowColor = currentPhaseIndex > prevPhaseIndex ? 'green-arrow' : 'red-arrow';
      entity.userDetails = entity.userDetails
        .map((user) => ({ ...user, date: datePipe.transform(user.transactionDate, 'dd-MMM-yy'), }))
        .sort((a, b) => {
          if (!a.date || !b.date) {
            return 0;
          }
          return a.date.localeCompare(b.date) || a.userName.localeCompare(b.userName);
        });
    });
  }
}
